/* Starbound Letters — wishlist page (Shopify edition) */
(function () {
  "use strict";
  const SB = window.SB;
  const grid = document.querySelector("[data-wishlist-grid]");
  if (!grid || !SB) return;
  const empty = document.querySelector("[data-wishlist-empty]");
  const root = (SB.root || "/").replace(/\/$/, "");
  const cache = {};

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(`${root}/products/${handle}.js`, { credentials: "same-origin" }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
    return cache[handle];
  }

  function card(p) {
    const paper = /paper art/i.test(p.type || "");
    const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, "_900x$1") : "";
    return `
      <div class="product-card" data-id="${SB.esc(p.handle)}">
        <a href="${root}/products/${SB.esc(p.handle)}" style="text-decoration:none">
          <div class="frame${paper ? " sheet" : ""}">${img ? `<img src="${SB.esc(img)}" alt="${SB.esc(p.title)}">` : `<div class="ph"><span><span class="star">✦</span><span class="label">Photography to come</span></span></div>`}</div>
          <div class="meta"><div class="title">${SB.esc(p.title)}</div>
          <div class="price">${SB.money(p.price)}</div></div>
        </a>
        <p style="text-align:center;margin-top:.4rem"><button class="remove" style="background:none;border:none;font-size:var(--fs-micro);letter-spacing:var(--track-mid);text-transform:uppercase;color:var(--ink-soft);text-decoration:underline;cursor:pointer" data-unwish="${SB.esc(p.handle)}">Remove</button></p>
      </div>`;
  }

  function render() {
    const handles = SB.wishlist();
    if (!handles.length) { grid.innerHTML = ""; empty.hidden = false; return; }
    Promise.all(handles.map(fetchProduct)).then((items) => {
      const found = items.filter(Boolean);
      empty.hidden = found.length !== 0;
      grid.innerHTML = found.map(card).join("");
    });
  }

  grid.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-unwish]");
    if (!btn) return;
    SB.toggleWish(btn.dataset.unwish);
    render();
  });
  render();
})();
